import {gsap} from "gsap";

export const init = (pauseTTS) => gsap.timeline({
    paused: true,
    onComplete: pauseTTS
});